// extracted by mini-css-extract-plugin
export default {"Container":"Tokenomics_Container__MxpTQ","Header":"Tokenomics_Header__C4AD+","Img":"Tokenomics_Img__P5ouD"};